<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.user-projects.title' | translate }}
    @if (modify) {
    <a href="javascript:void(0)" (click)="pjpop()" class="modify-btn"
      pTooltip="{{ 'widgets.user-projects.edit' | translate }}">
      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
    </a>
    }
    <small class="date-font"><i>({{initialDate | dateMoment:shortDate}} - {{finalDate |
        dateMoment:shortDate}})</i></small>
  </div>

  <div class="amSuite-widget-block height-auto">

    @if (projects && projects.length > 0) {
    <div class="cw-list">
      @for (prj of projects; track $index) {
      <article class="cw-row">
        <span class="cw-ico" role="img" [attr.aria-label]="getStateLabel(prj.workingState)">
          <p-tag [severity]="stateConfig[prj.workingState].severity"
                [icon]="stateConfig[prj.workingState].icon + ' font-semibold'"
                [rounded]="true"
                styleClass="p-tag-outlined">
          </p-tag>
        </span>
        <div class="cw-main">
          <a class="cw-rtitle" href="javascript:void(0)" (click)="modify ? '' : onSelectProject(prj)"
            [pTooltip]="prj.title" tooltipPosition="bottom">{{ prj.title }}</a>
          <div class="cw-who">{{ prj.ownerFullName }}</div>
          <div class="cw-date">{{ prj.referenceDate | dateMoment:shortDate }}</div>
          <p-progressBar class="cw-progress" [value]="prj.progress" [showValue]="false"></p-progressBar>
        </div>
        <div class="cw-aside">
          <div class="cw-flags">
            @if (prj.isShared) {
              <span class="cw-flag" [pTooltip]="'widgets.user-projects.sharedWithMe' | translate">
                <i class="pi pi-share-alt" aria-hidden="true"></i>
              </span>
            }
            @if (prj.isSharedByOwner) {
              <span class="cw-flag" [pTooltip]="'widgets.user-projects.sharedByMe' | translate">
                <i class="pi pi-cloud" aria-hidden="true"></i>
              </span>
            }
          </div>
          <p-button styleClass="cw-cal" (click)="selectedProject = prj;activities.toggle($event)"
            icon="pi pi-calendar" [pTooltip]="'widgets.user-projects.projectDetails' | translate"></p-button>
        </div>
      </article>
      }
    </div>
    }
    @if (projects && projects.length === 0) {
    <div>
      <div class="row noResultsLabel"> {{ 'app.noData' | translate }}</div>
    </div>
    }
    @if (!projects) {
    <div>
      <div class="m-0 o-0">
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div>
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <p-overlayPanel #activities appendTo="body" styleClass="cw-activities-pop"
    (onShow)="onPanelShow()" (onHide)="onPanelHide()">
    <ng-template pTemplate>
      @if (selectedProject) {
      <div class="cw-pop" role="group"
        [attr.aria-label]="'widgets.user-projects.activities-panel-title' | translate">
        <div class="cw-pop-head">
          <span class="cw-pop-title">{{ 'widgets.user-projects.activities-panel-title' | translate }}</span>
          <span class="cw-pop-count" aria-hidden="true">{{ selectedProject.activities?.length || 0 }}</span>
        </div>

        @if (selectedProject.activities && selectedProject.activities.length > 0) {
        <ul class="cw-acts">
          @for (activity of selectedProject.activities; track $index) {
          <li class="cw-act">
            <span class="cw-ico" role="img" [attr.aria-label]="getStateLabel(activity.workingState)">
              <p-tag [severity]="stateConfig[activity.workingState].severity"
                    [icon]="stateConfig[activity.workingState].icon + ' font-semibold'"
                    [rounded]="true"
                    styleClass="p-tag-outlined">
              </p-tag>
            </span>
            <button type="button" class="cw-act-main"
              [pTooltip]="activity.subject + ' - ' + activity.ownerFullName" tooltipPosition="bottom"
              (click)="onSelectActivity(activity)"
              [attr.aria-label]="'widgets.user-projects.activity-item-label' | translate:{ subject: activity.subject, owner: activity.ownerFullName }">
              <span class="cw-act-title">{{ activity.subject }}</span>
              @if (activity.ownerFullName) {
                <span class="cw-act-who">{{ activity.ownerFullName }}</span>
              }
            </button>
          </li>
          }
        </ul>
        } @else {
        <div class="cw-pop-empty">{{ 'widgets.user-projects.no-activities' | translate }}</div>
        }
      </div>
      }
    </ng-template>
  </p-overlayPanel>
